import {defineStore} from "pinia";
import {
    calculateSubscription,
    calculateUpgradePrice,
    createRenewSubscriptionInvoice,
    createUpgradeSubscriptionInvoice
} from "@/scripts/api/subscription";
import {PlanType} from "@/scripts/types/account";
import {useToast} from "vue-toastification";

const toast = useToast();

const useSubscription = defineStore('subscription', {
    actions: {
        async createRenewSubscriptionInvoice(plan: PlanType, months: number) {
            try {
                return await createRenewSubscriptionInvoice(plan, months);
            } catch (error: any) {
                toast.error("Возникла ошибка, попробуйте еще раз");
            }
        },

        async createUpgradeSubscriptionInvoice(plan: PlanType) {
            try {
                return await createUpgradeSubscriptionInvoice(plan);
            } catch (error: any) {
                toast.error("Возникла ошибка, попробуйте еще раз");
            }
        },

        async calculateSubscriptionPrice(plan: PlanType, months: number) {
            try {
                return await calculateSubscription(plan, months);
            } catch (error: any) {
            }
        },

        async calculateUpgradePrice(plan: PlanType) {
            try {
                return await calculateUpgradePrice(plan);
            } catch (error: any) {
            }
        }
    }
});

export default useSubscription;